import { Modal } from "react-bootstrap"

const ChangePasswordModal = ({ setChangePassword, changePassword, onSubmit, requireCurrent }) => {
    const close = () => setChangePassword((prev) => ({ ...prev, show: false }));

    return (
        <Modal show={changePassword.show} onHide={close} centered>
            <Modal.Header closeButton><h3 className="dialog-modal-text">Change Password</h3></Modal.Header>
            <Modal.Body>
                <form onSubmit={onSubmit}>
                    {/* Shown when a user changes their own password, where the
                        server requires the current one. Admins resetting
                        someone else's password don't supply it. */}
                    {requireCurrent && <div className="form-group mb-4">
                        <label htmlFor="current-password">Current Password*</label>
                        <input
                            id="current-password"
                            required
                            placeholder="Enter current password"
                            type="password"
                            className="form-control"
                            name="current-password"
                            autoComplete="current-password"
                            value={changePassword.current_password ?? ""}
                            onChange={(e) => setChangePassword((prev) => ({ ...prev, current_password: e.target.value }))}
                        />
                    </div>}
                    <div className="form-group mb-4">
                        <label htmlFor="change-password">Password*</label>
                        <input
                            id="change-password"
                            required
                            minLength={6}
                            placeholder="Enter password"
                            type="password"
                            className="form-control"
                            name="password"
                            autoComplete="new-password"
                            value={changePassword.password ?? ""}
                            onChange={(e) => setChangePassword((prev) => ({ ...prev, password: e.target.value }))}
                        />
                    </div>
                    <div className="form-group mb-4">
                        {/* Both fields previously shared id="form-password", so
                            clicking the second label focused the first input. */}
                        <label htmlFor="change-repeat-password">Repeat Password*</label>
                        <input
                            id="change-repeat-password"
                            required
                            minLength={6}
                            placeholder="Repeat password"
                            type="password"
                            className="form-control"
                            name="repeat-password"
                            autoComplete="new-password"
                            value={changePassword.repeat_password ?? ""}
                            onChange={(e) => setChangePassword((prev) => ({ ...prev, repeat_password: e.target.value }))}
                        />
                    </div>
                    <div className="modal-action-buttons">
                        <button type="submit" disabled={changePassword.loader} className="submit-modal-form-btn">
                            {changePassword.loader ? <div className="button-loader"></div> : "Submit"}
                        </button>
                        <button type="button" onClick={close} className="cancel-modal-form-btn">Cancel</button>
                    </div>
                </form>
            </Modal.Body>
        </Modal>
    )
}

export default ChangePasswordModal
